<template>
	<div>
		<div v-if="!smallScreen">
			<nav v-if="activeRouteName !== 'Error404' && activeRouteName !== 'AutoLogin'" class="navbar navbar-main navbar-expand-lg sticky-top hidden-sm" :class="{ 'shrink': shrink }">
				<div class="container-fluid">
					<router-link class="navbar-brand mr-4" to="/" v-if="activeRouteName !== 'RundownEditor'">
						<img src="/img/icon-512.png" class="d-inline-block align-top" alt="Grafias">
					</router-link>
					<!-- menu popup rundown -->
					<button
						v-if="activeRouteName === 'RundownEditor'"
						type="button"
						class="btn-icon btn-brand-composition btn"
						v-click-outside="hideContext" @click="toggleContextDashboard()" ref="dropdownContextDashboard">
						<img src="/img/icon-512.png" class="navbar-brand-composition" alt="Grafias">
						<i class="material-icons pb-1 mt-1 ml-2">expand_more</i>
					</button>
					<ul v-if="dashboardOpened" class="dropdown-context-dashboard-item">
						<li class="text-white-context pl-4 pb-2 pt-2" @click="goTo('/')">
							<label class="link-white-nodecor pointer">{{ $t('Dashboard') }}</label>
						</li>
						<li @click="isProgramMonitorVisible = true" class="text-white-context pl-4 pb-2 pt-2">
							<label class="link-white-nodecor">{{ $t('Device Monitor') }}</label>
						</li>
						<li class="text-white-context pl-4 pb-2 pt-2" @click="goTo('/compositions')">
							<label class="link-white-nodecor pointer pt-0 mt-0">{{ $t('Composition') }}</label>
						</li>
						<li class="text-white-context pl-4 pb-2 pt-2" @click="goTo('/displays')">
							<label class="link-white-nodecor">{{ $t('View Output') }}</label>
						</li>
					</ul>
					<div class="navbar-separator ml-0"></div>
					<div class="nav-page-title" v-if="activeRouteName !== 'RundownEditor'">{{ title }}</div>
					<div @dblclick="isRenameVisible = true" class="nav-page-title pointer"
						v-if="activeRouteName === 'RundownEditor'"
						v-click-outside="hideContextRundown" @contextmenu.prevent @contextmenu="toggleContextRundown()" ref="dropdownContextRundown">
						{{ rundown && nameRundown ? nameRundown : '' }}
						<ul v-if="rundownOpened" class="dropdown-context-rundown-main-item">
							<li class="text-white-context pl-4 pb-2 pt-2" @click="goTo('/')">
							{{$t('All Rundown')}}
							</li>
							<li class="text-white-context pl-4 pb-2 pt-2" @click="createRundown2()">
								{{$t('New Rundown')}}
							</li>
							<li class="text-white-context pl-4 pb-2 pt-2" v-for="item in rundowns" :key="item.id">
								<label class="text-white pr-4" @click="goToRundown(item.slug)">{{item.name}}</label>
							</li>
						</ul>
					</div>

					<!-- main nav -->
					<div></div>
					<button type="button" class="navbar-toggler">
						<span class="navbar-toggler-icon"></span>
					</button>
					<div class="main-nav-dropdown collapse navbar-collapse justify-content-between">
						<ul class="navbar-nav d-flex justify-content-center">
							<li class="nav-item hidden" :class="{ 'active': isMenuActive('/') }">
								<router-link class="nav-link nav-link-text" to="/">
									<!-- <span class="link-label">{{ $t('menu.home') }}</span> -->
								</router-link>
							</li>
						</ul>
						<ul class="navbar-nav">
							<li v-if="user && !isCollaborator && activeRouteName !== 'RundownEditor'">
								<a class="btn btn-primary text-white mr-3 mt-2" :class="{ 'is-loading': isCreatingRundown }" @click="createRundown()">
									{{ $t('New Rundown') }}
								</a>
							</li>
							<li v-if="user && !isCollaborator && activeRouteName !== 'RundownEditor' || isUserCollaboratorOperator">
								<router-link
									class="btn btn-primary text-white mr-3 mt-2"
									to="/compositions/editor">
									{{ $t('New Composition') }}
								</router-link>
							</li>
							<li v-if="user && !isCollaborator && activeRouteName !== 'RundownEditor'">
								<a
									class="btn btn-primary text-white mt-2"
									@click="addProgramMonitor">
									{{ $t('Device Monitor') }}
								</a>
							</li>
							<!-- display menu -->
							<li>
								<button v-if="activeRouteName === 'RundownEditor' && userCollaborators !== 'event_manager'"
									type="button"
									:class="{ 'is-loading': isFetching }"
									v-click-outside="hideContextDisplay" ref="dropdownContextDisplay"
									class="btn btn-primary btn-display-output btn-icon" @click.stop="fetchDisplay()">
									<i class="material-icons">monitor</i>
									<label class="mt-2">View output</label>
									<i v-if="!isFetching" class="material-icons pb-1 mt-1">expand_more</i>
									<ul v-if="displayOpened" class="dropdown-context-display-item">
										<!-- Attach Display Output -->
										<li @click.stop="addOutputDisplay" class="text-white-context pl-4 pr-4 pt-2 text-left">
											{{ $t('Manage Output') }}
										</li>
										<li v-if="!isFetching && filteredDisplay.length > 0" class="pb-2 mt-2 text-left">
											<div class="p-5 text-center" v-if="isFetching">
												<div class="is-loading large"></div>
											</div>
											<span class="text-grey pl-4 pr-4">{{ $t('Active Output') }}</span>
										</li>
										<ul v-for="item in displaysActive" :key="item.id" class="nonstyle pl-0">
											<li v-if="item.rundown_id === rundown.id && !isFetching" class="text-white-context text-left"
												@click.stop="viewDisplay(item)">
												<div class="pl-4 pr-4 pt-1 truncate-display-name">{{ printNameDisplay(item) }}</div>
											</li>
										</ul>
									</ul>
								</button>
							</li>
							<li class="clock-time ml-3 minw-50">
								{{ clockTime }}
							</li>
							<li>
								<profile-dropdown></profile-dropdown>
							</li>
							<!-- Profile -->
							<li class="nav-item dropdown profile-menu hidden" v-if="user">
								<div class="nav-link p-0">
									<md-menu md-size="big" md-direction="bottom-end" md-align-trigger>
										<md-button class="btn-fluid ml-3" v-tooltip="fullname" :md-ripple="false" md-menu-trigger>
											<div class="flex-center-left">
												<span class="mr-2 pt-1">{{ user.name }}</span>
												<div
													class="profile-image"
													:style="{ backgroundImage: `url('${user.picture}')` }"
													v-if="user.picture && user.picture !== ''">
												</div>
												<i class="material-icons profile-image" v-else>account_circle</i>
											</div>
										</md-button>
										<md-menu-content>
											<md-menu-item @click="$router.push('/profile')">{{ $t('Profile') }}</md-menu-item>
											<md-menu-item @click="logout()">{{ $t('Logout') }}</md-menu-item>
										</md-menu-content>
									</md-menu>
								</div>
							</li>
							<!-- Help -->
							<li class="nav-item m-0 hidden">
								<a class="nav-link help-toggle cur-p" v-tooltip="$t('Help')" @click="showHelp">
									<div class="help-icon icon-toggle">
										<i class="material-icons">help</i>
									</div>
									<!-- <div class="label ml-2">Help</div> -->
								</a>
							</li>
						</ul>
						<!-- program monitor -->
						<modal-program-monitor
						@close="isProgramMonitorVisible = false"
						v-if="isProgramMonitorVisible">
						</modal-program-monitor>
						<modal-output-display
						@close="isOutputDisplayVisible = false"
						v-if="isOutputDisplayVisible">
						</modal-output-display>
					</div>
				</div>
				<!-- Rename Rundown -->
					<modal class="absolute"
						@close="isRenameVisible = false"
						v-if="isRenameVisible">
						<template slot="header">
							<h3>{{ $t('Rename Rundown') }}</h3>
						</template>
						<template slot="body">
							<div class="form-group mb-3">
								<input
									type="text"
									class="form-control"
									:placeholder="$t('Rundown Name')"
									v-model="nameRundown"
								/>
							</div>
						</template>
						<template slot="footer">
							<button
								type="button"
								class="btn btn-primary"
								:class="{ 'is-loading': isSavingRundown }"
								@click="update">
								{{ $t('Save') }}
							</button>
							<button
								type="button"
								class="btn btn-default"
								@click="closeRename">
								{{ $t('Cancel') }}
							</button>
						</template>
					</modal>
			</nav>
		</div>
		<div v-if="smallScreen">
		<nav>
			<nav v-if="activeRouteName !== 'Error404' && activeRouteName !== 'AutoLogin'" class="navbar navbar-main navbar-expand-lg sticky-top" :class="{ 'shrink': shrink }">
				<!-- Profile -->
				<div class="d-flex justify-content-between">
					<div class="ml-a">
						<img @click="goTo('/')" src="/img/icon-512.png" class="navbar-brand-composition" alt="Grafias"> <span class="text-default ml-3 text-xlg" v-if="activeRouteName === 'dashboard'">Rundown</span>
						<div class="profile-dropdown-mobile"><profile-dropdown></profile-dropdown></div>
					</div>
					<div @dblclick="isRenameVisible = true" class="nav-page-title pointer ml-2"
						v-if="activeRouteName === 'RundownEditor'"
						v-click-outside="hideContextRundown" @contextmenu.prevent @contextmenu="toggleContextRundown()" ref="dropdownContextRundown">
						{{ rundown && nameRundown ? nameRundown : '' }}
						<ul v-if="rundownOpened" class="dropdown-context-rundown-main-item">
							<li class="text-white-context pl-4 pb-2 pt-2" @click="goTo('/')">
							{{$t('All Rundown')}}
							</li>
							<li class="text-white-context pl-4 pb-2 pt-2" v-for="item in rundowns" :key="item.id">
								<label class="text-white pr-4" @click="goToRundown(item.slug)">{{item.name}}</label>
							</li>
						</ul>
					</div>
					<!-- <div class="ml-a">
						<profile-dropdown></profile-dropdown>
					</div> -->
				</div>
			</nav>
		</nav>
	</div>
	</div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { mapGetters, mapActions } from 'vuex';
import ProfileDropdown from './ProfileDropdown.vue';
import ModalProgramMonitor from './ModalProgramMonitor.vue';
import ModalOutputDisplay from './ModalOutputDisplay.vue';
import displaysApi from '@/api/displays';
import Modal from '@/components/Modal.vue';

import {
	getAxiosErrorMessage,
	copyToClipboard,
	duplicateVar,
} from '@/lib/helper';
import rundownsApi from '@/api/rundowns';

export default {
	name: 'mainNav',
	components: {
		ProfileDropdown,
		ModalProgramMonitor,
		ModalOutputDisplay,
		Modal,
	},
	data() {
		return {
			shrink: false,
			isProgramMonitorVisible: false,
			clockTime: '',
			isCreatingRundown: false,
			isOutputDisplayVisible: false,
			rundown: null,
			displaysActive: [],
			isFetching: false,
			isRenameVisible: false,
			isSavingRundown: false,
			nameRundown: '',
			rundowns: [],
			dashboardOpened: false,
			displayOpened: false,
			rundownOpened: false,
			smallScreen: false,
		};
	},
	directives: {
		ClickOutside,
	},
	sockets: {
		connect() {
		},
		rundown_update(payload) {
			this.rundown = duplicateVar(payload);
			this.nameRundown = payload.name;
		},
	},
	methods: {
		toggleContextDashboard() {
			this.dashboardOpened = !this.dashboardOpened;
		},
		toggleContextDisplay() {
			this.displayOpened = !this.displayOpened;
		},
		toggleContextRundown() {
			this.rundownOpened = !this.rundownOpened;
		},
		hideContext() {
			this.dashboardOpened = false;
		},
		hideContextDisplay() {
			this.displayOpened = false;
		},
		hideContextRundown() {
			this.rundownOpened = false;
		},
		...mapActions({
			logout: 'logout',
			switchRole: 'switchRole',
			setSwitcherState: 'setSwitcherState',
			setHelpState: 'setHelpState',
		}),
		printLayerIndex(item) {
			const layerIndex = item && item.layer_index ? JSON.parse(item.layer_index) : null;
			if (Array.isArray(layerIndex) && layerIndex.length && !layerIndex.includes('0')) {
				return JSON.parse(item.layer_index).toString();
			}
			return 'All';
		},
		printNameDisplay(item) {
			const index = this.printLayerIndex(item);
			const name = item.name;
			const fullName = `${name}  (${index})`;
			return fullName;
		},
		handleScroll() {
			const scrollPosition = window.scrollY;
			const treshold = 0;
			if (scrollPosition > treshold) {
				this.shrink = true;
			} else {
				this.shrink = false;
			}
		},
		isUserCan(capability) {
			return this.user && this.user.capabilities.includes(capability);
		},
		showHelp() {
			this.setHelpState(true);
		},
		addProgramMonitor() {
			this.isProgramMonitorVisible = true;
		},
		addOutputDisplay() {
			this.displayOpened = false;
			this.isOutputDisplayVisible = true;
		},
		updateTime() {
			const cd = new Date();
			this.clockTime = `${this.zeroPadding(cd.getHours(), 2)}:${this.zeroPadding(cd.getMinutes(), 2)}:${this.zeroPadding(cd.getSeconds(), 2)}`;
		},

		zeroPadding(num, digit) {
			let zero = '';
			for (let i = 0; i < digit; i++) {
				zero += '0';
			}
			return (zero + num).slice(-digit);
		},
		createRundown() {
			this.isCreatingRundown = true;
			const callback = (response) => {
				const rundown = response.data;
				this.$router.push(`/rundowns/editor/${btoa(rundown.slug)}`);
				this.isCreatingRundown = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown',
					text: message,
				});
				this.isCreatingRundown = false;
			};
			const params = {
				name: 'My Event Rundown',
			};
			rundownsApi.create(params, callback, errorCallback);
		},
		copyUrl() {
			const slug = this.activeRouteSlug;
			const url = `${window.location.host}/rundowns/editor/${btoa(slug)}`;
			copyToClipboard(url);
			const message = this.$t('Copied to clipboard');
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Copy URL',
				text: message,
			});
		},
		getRundownData() {
			if (!this.activeRouteSlug) return;
			const callback = (response) => {
				const rundown = response.data;
				this.rundown = rundown;
				this.nameRundown = this.rundown.name;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown',
					text: message,
				});
			};
			rundownsApi.getBySlug(atob(this.activeRouteSlug), callback, errorCallback);
		},
		fetchDisplay() {
			this.isFetching = true;
			const rundownId = this.rundown && this.rundown.id ? this.rundown.id : null;
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'id',
				sort_by: 'asc',
				rundown_id: rundownId,
			};
			const callback = (response) => {
				const items = response.data;
				this.displaysActive = items;
				this.isFetching = false;
				this.displayOpened = true;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: '',
					text: message,
				});
				this.isFetching = false;
			};
			displaysApi.getList(params, callback, errorCallback);
		},
		viewDisplay(item) {
			this.displayOpened = false;
			const rundownId = item && item.rundown && item.rundown.id ? item.rundown.id : '';
			const url = `/displays/live/${item.slug}/${item.id}?rundown_id=${rundownId}`;
			const routeData = this.$router.resolve({ path: url });
			window.open(routeData.href, '_blank');
		},
		update() {
			this.isSavingRundown = true;
			const id = this.rundown.id;
			const name = this.nameRundown.trim();
			const params = {
				name,
			};
			const callback = (response) => {
				const rundown = response.data;
				this.rundown = rundown;
				this.$router.push(`/rundowns/editor/${btoa(rundown.slug)}`).catch(() => {});
				this.isSavingRundown = false;
				this.isRenameVisible = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update Rundown',
					text: message,
				});
				this.isSavingRundown = false;
			};
			rundownsApi.update(id, params, callback, errorCallback);
		},
		closeRename() {
			this.isRenameVisible = false;
			this.rundown.name = '';
		},
		goTo(route) {
			this.$router.push(route);
			this.dashboardOpened = false;
		},
		goToRundown(route) {
			const routeData = this.$router.resolve(`/rundowns/editor/${btoa(route)}`);
			window.open(routeData.href, '_self');
			this.hideContextRundown();
		},
		createRundown2() {
			this.isCreatingRundown = true;
			const callback = (response) => {
				const rundown = response.data;
				const routeData = this.$router.resolve(`/rundowns/editor/${btoa(rundown.slug)}`);
				window.open(routeData.href, '_blank');
				this.isCreatingRundown = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown',
					text: message,
				});
				this.isCreatingRundown = false;
			};
			const params = {
				name: 'My Event Rundown',
			};
			rundownsApi.create(params, callback, errorCallback);
		},
		fetchRundown() {
			const params = {
				page: 1,
				limit: 5,
				order_by: 'id',
				sort_by: 'desc',
				user_id: this.userId,
			};
			const callback = (response) => {
				const rundowns = response.data;
				this.rundowns = rundowns;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown',
					text: message,
				});
			};
			rundownsApi.getList(params, callback, errorCallback);
		},
		onClick(e) {
			const el = this.$refs.dropdownContextDashboard;
			const isElementExist = el && el !== undefined;
			const target = e.target;
			if (e.target && isElementExist) {
				if ((el !== target) && !el.contains(target)) {
					this.dashboardOpened = false;
					this.displayOpened = false;
				}
			}
		},
		onClickRundown(e) {
			const el = this.$refs.dropdownContextRundown;
			const isElementExist = el && el !== undefined;
			const target = e.target;
			if (e.target && isElementExist) {
				if ((el !== target) && !el.contains(target)) this.rundownOpened = false;
			}
		},
		onResizeWidth() {
			if (window.innerWidth <= 1024) {
				this.smallScreen = true;
			} else {
				this.smallScreen = false;
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			role: 'role',
			isMenuActive: 'isMenuActive',
			isSuperAdmin: 'isSuperAdmin',
			isClient: 'isClient',
			isCollaborator: 'isCollaborator',
		}),
		fullname() {
			return this.user.name;
		},
		roles() {
			return this.user ? this.user.roles : [];
		},
		userId() {
			return this.user ? this.user.id : '';
		},
		title() {
			return this.$route.meta.gtm || 'Grafias';
		},
		userCollaborators() {
			const currentRoleCollaborator = '';
			if (this.rundown && this.rundown.id) {
				const data = this.user && this.user.collaborators ? this.user.collaborators : '';
				// eslint-disable-next-line
				const current = data.find(({ rundown_ids }) => rundown_ids.includes(this.rundown && this.rundown.id));
				const currentRoleCollaborator = current && current.role ? current.role : '';
				return currentRoleCollaborator;
			}
			return currentRoleCollaborator;
		},
		isUserCollaboratorOperator() {
			let roleCollaborator = false;
			if (this.user && this.user.collaborators.length >= 1) {
				const data = this.user && this.user.collaborators ? this.user.collaborators : '';
				// eslint-disable-next-line
				for (let index = 0; index < data.length; index++) {
					if (data[index].role === 'operator') {
						// eslint-disable-next-line
						return roleCollaborator = true;
					}
				}
				// eslint-disable-next-line
				return roleCollaborator = false;
			}
			return roleCollaborator;
		},
		activeRouteName() {
			return this.$route.name;
		},
		activeRouteSlug() {
			return this.$route.params.slug;
		},
		filteredDisplay() {
			const filter = item => (item.rundown_id === this.rundown.id);
			return this.displaysActive.filter(filter);
		},
	},
	created() {
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
		window.addEventListener('scroll', this.handleScroll);
		// eslint-disable-next-line no-unused-vars
		const timerId = setInterval(this.updateTime, 1000);
		window.addEventListener('contextmenu', this.onClick);
		window.addEventListener('contextmenu', this.onClickRundown);
		if (this.userId) {
			this.fetchRundown();
		}
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
		window.removeEventListener('contextmenu', this.onClick);
		window.removeEventListener('contextmenu', this.onClickRundown);
	},
	watch: {
		rundown() {
			if (this.rundown) {
				const roomId = `rundown_${this.rundown.slug}`;
				this.$socket.client.emit('join', roomId);
			}
		},
		activeRouteSlug() {
			if (this.activeRouteSlug) {
				this.getRundownData();
				return this.rundown;
			}
			return this.rundown;
		},
		userId() {
			if (this.userId) this.fetchRundown();
		},
		nameRundown(val) {
			this.nameRundown = val.replace(/[^A-Z0-9 ]/gi, '');
		},
	},
	mounted() {
		if (!this.rundown) this.getRundownData();
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
	},
};
</script>
<style>
@import '~vue-context/dist/css/vue-context.css';
</style>
